module.exports = __webpack_public_path__ + "assets/img/1176.22398bf3.png";